<div class="cntnr">
    <div class="cmny_dtl_form">
        <form [formGroup]="companyForm">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="companyName">Company name</label>
                        <input type="text" class="form-control"
                            [class.req-field]="isSaved && companyForm.get('companyName')?.hasError('required')"
                            id="companyName" formControlName="companyName" placeholder="Enter company name" />
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="companyType">Company Type</label>
                        <div class="dropdown">
                            <button class="form-select ddlBtn"
                                [class.req-field]="isSaved && companyForm.get('companyTypeId')?.hasError('required')"
                                id="companyType" data-bs-toggle="dropdown">
                                {{companyForm.get('companyType')?.value}}
                            </button>

                            <div class="dropdown-menu">
                                <ul>
                                    <li *ngFor="let companyType of companyTypeDdl">
                                        <a class="dropdown-item"
                                            (click)="onCompanyTypeChange(companyType)">{{companyType.name}}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="city">City</label>
                        <div class="dropdown">
                            <button class="form-select ddlBtn"
                                [class.req-field]="isSaved && companyForm.get('cityId')?.hasError('required')" id="city"
                                data-bs-toggle="dropdown">
                                {{companyForm.get('city')?.value}}
                            </button>

                            <div class="dropdown-menu">
                                <div class="search_box">
                                    <input type="text" [(ngModel)]="searchString" [ngModelOptions]="{standalone: true}"
                                        (input)="onCitySearch($event)" id=" citySearch" placeholder="Search city">
                                </div>
                                <ul>
                                    <li *ngFor="let city of cityDdl">
                                        <a class="dropdown-item" (click)="onCityChange(city)">{{city.name}}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="postalCode">Postal Code</label>
                        <input type="text" class="form-control" appInputNumber maxlength="6"
                            [class.req-field]="isSaved && companyForm.get('postalCode')?.hasError('required')"
                            id="postalCode" formControlName="postalCode" placeholder="Enter postal code" />
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label for="address">Address</label>
                        <textarea class="form-control" id="address"
                            [class.req-field]="isSaved && companyForm.get('address')?.hasError('required')" rows="3"
                            formControlName="address" placeholder="Enter address"></textarea>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-check mb-2 ms-1">
                        <input class="form-check-input" type="checkbox" formControlName="isDummyData"
                            id="flexCheckDefault">
                        <label class="form-check-label" for="flexCheckDefault">
                            Generate Dummy Data
                        </label>
                    </div>
                </div>
            </div>

            <button type="submit" class="btn btn-primary" [disabled]="isApiLoading" (click)="submit()">COMPLETE TRIAL
                SIGN-UP
                <span *ngIf="isApiLoading" class="spinner-border spinner-border-sm mx-2" aria-hidden="true"></span>
            </button>
        </form>
    </div>
</div>